import React from 'react';
import { Link } from 'react-router-dom';

const NdaBelgiumHero = () => (
  <section className="bg-gradient-to-br from-[#2F4E6F] to-[#1e3550] text-white py-20 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <div className="inline-block bg-[#FF8C00]/20 text-[#FF8C00] text-sm font-semibold px-4 py-1.5 rounded-full mb-6 border border-[#FF8C00]/30">
        Gratis NDA Template — België
      </div>
      <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
        NDA Template voor Belgische
        <span className="block text-[#FF8C00] mt-2">Freelancers en Zelfstandigen</span>
      </h1>
      <p className="text-xl text-blue-100 mb-4 max-w-2xl mx-auto">
        Bescherm vertrouwelijke informatie van jouw Belgische opdrachtgevers met een professionele geheimhoudingsovereenkomst. Juridisch correct naar Belgisch recht — gratis te genereren via Pactorae.
      </p>
      <p className="text-sm text-blue-200 mb-8 max-w-xl mx-auto">
        Speciaal voor zelfstandigen en freelancers in België. Inclusief ondernemingsnummer en btw-nummer velden.
      </p>
      <Link
        to="/contract-generator"
        className="inline-block bg-[#FF8C00] hover:bg-[#e07b00] text-white font-semibold px-8 py-4 rounded-lg text-lg transition-colors duration-200 shadow-lg"
      >
        Genereer jouw contract gratis
      </Link>
    </div>
  </section>
);

export default NdaBelgiumHero;
